import { cva } from 'class-variance-authority';

export const cvaUpperSubtitle = cva([
  'ff-inter',
  'pricingCard-cvaUpperSubtitle',
  'font-normal text-[20px] leading-[24px] text-[#6E718F] mb-2',
  'sm-max:text-[1rem]',
]);

export const cvaMainTitle = cva([
  'pricingCard-cvaMainTitle',
  'ff-raleway font-bold text-[48px] leading-[56px] text-main_black mb-6',
  'sm-max:text-[2.5rem] sm-max:mb-[1rem]',
]);

export const cvaSecondaryTitle = cva([
  'pricingCard-cvaSecondaryTitle',
  'text-font_raleway_title_black_32 text-main_black mb-4',
]);

export const cvaSubtitle = cva([
  'ff-inter',
  'pricingCard-cvaSubtitle',
  'text-font_ds_title_body_body_20 text-main_black mb-4',
]);

export const cvaDescription = cva([
  'ff-inter',
  'pricingCard-cvaDescription',
  'text-font_raleway_body_16 text-general_text_MII_secondary_i',
]);

export const cvaSelectCard = cva([
  'pricingCard-cvaSelectCard',
  'flex flex-col gap-3 bg-main_dark_blue rounded-[1.5rem] p-10',
  'text-center',
  'sm-max:p-[2.5rem] sm-max:gap-y-[1rem]',
  'xs-max:p-[1.5rem] xs-max:gap-y-[0.5rem]',
]);

export const cvaSelectCardTitle = cva([
  'pricingCard-cvaSelectCardTitle',
  'text-font_raleway_body_black_24 text-main_white',
  'sm-max:text-[1.5rem] sm-max:mb-0',
]);

export const cvaSelectCardDescription = cva([
  'pricingCard-cvaSelectCardDescription',
  'text-font_raleway_body_black_16 text-main_white mt-4',
  'sm-max:text-[0.8125rem] sm-max:mt-[0]',
]);

export const cvaSelectCardDescriptionWithGuard = cva([
  'pricingCard-cvaSelectCardDescriptionWithGuard',
  'ff-inter font-bold text-[16px] leading-[20px] text-[#FFDA2B]',
  'border border-dashed border-[#FFDA2B] rounded-[16px]',
  'py-3 px-3',
  'flex items-center gap-2 justify-center',
  'mt-4',
  'sm-max:mt-[0]',
]);

export const cvaRadioButtons = cva([
  'pricingCard-cvaRadioButtons',
  'flex flex-col gap-2 mb-4',
  'sm-max:gap-y-[0.5rem] sm-max:mb-[0]',
  'whitespace-nowrap',
]);

export const cvaRadioButton = cva(
  [
    'ff-os-hebrew',
    'pricingCard-cvaRadioButton',
    'flex sm-max:flex-col border w-full border-solid',
    'border-main_white rounded-2xl px-6 py-4 justify-between',
    'transition-all duration-250 ease-out',
    'sm-max:justify-start',
    'xxs-max:px-4 xxs-max:py-2',
  ],
  {
    variants: {
      isActive: {
        true: '',
        false: 'opacity-[0.72]',
      },
    },
  },
);

export const cvaRadioButtonContent = cva([
  'pricingCard-cvaRadioButtonContent',
  'flex items-center gap-2 flex-grow',
]);

export const cvaRadioButtonIcon = cva(
  [
    'pricingCard-cvaRadioButtonIcon',
    'relative w-5 h-5 border-2 border-solid border-main_green rounded-full flex items-center justify-center',
    'transition-all duration-250 ease-out',
    'after:content-[""] after:w-[0.625rem] after:h-[0.625rem] after:bg-main_white after:rounded-full',
  ],
  {
    variants: {
      isActive: {
        true: 'bg-main_green after:opacity-100',
        false: 'after:opacity-0',
      },
    },
  },
);

export const cvaRadioButtonText = cva([
  'pricingCard-cvaRadioButtonText',
  'ff-os-hebrew font-bold text-[24px] leading-[28px] text-main_white text-left',
]);

export const cvaRadioButtonBenifit = cva([
  'pricingCard-cvaRadioButtonBenifit',
  'flex items-center justify-center',
  'text-font_os_body_caption_13 text-main_yellow',
  'border border-dashed border-main_yellow rounded px-2 h-6',
  'sm-max:col-start-2',
]);

export const cvaRadioButtonPrice = cva([
  'pricingCard-cvaRadioButtonPrice',
  'flex flex-col items-end sm-max:items-start',
  'sm-max:grid sm-max:grid-cols-[auto_1fr] sm-max:gap-x-2',
  'sm-max:justify-items-start',
]);

export const cvaRadioButtonPriceValue = cva([
  'pricingCard-cvaRadioButtonPriceValue',
  'ff-os-hebrew font-bold text-[24px] leading-[28px] text-main_white',
]);

export const cvaRadioButtonAiTokensText = cva([
  'pricingCard-cvaRadioButtonAiTokensText',
  'ff-os-hebrew font-bold text-[16px] leading-[12px] text-main_white text-right',
]);

export const cvaRadioButtonPriceDescription = cva([
  'pricingCard-cvaRadioButtonPriceDescription',
  'text-font_os_body_caption_12 text-main_white',
  'sm-max:col-span-full',
]);

export const cvaPaygSelectCardRoot = cva([
  'pricingCard-paygSelectCardRoot',
  'flex flex-col items-center text-center',
  'border-2 border-dashed border-main_dark_blue rounded-[1.5rem] p-10',
  'xs-max:p-[1.5rem]',
]);

export const cvaPaygSelectCardTitle = cva([
  'pricingCard-paygSelectCardTitle',
  'text-font_raleway_body_black_24 text-main_black mb-4',
]);

export const cvaPaygSelectCardDescription = cva([
  'pricingCard-paygSelectCardDescription',
  'text-font_raleway_body_black_16 text-main_black mt-4',
]);

export const cvaPaygSelectCardContent = cva([
  'ff-os-hebrew',
  'pricingCard-paygSelectCardContent',
  'flex rounded-2xl border border-solid border-main_black px-6 py-4 items-center justify-between w-full',
  'mb-4',
  'sm-max:flex-col sm-max:gap-y-2',
  'whitespace-nowrap',
]);

export const cvaPaygSelectCardContentItem = cva(
  [
    'pricingCard-paygSelectCardContentItem',
    'flex flex-col',
    'sm-max:flex-col sm-max:items-start sm-max:w-full',
  ],
  {
    variants: {
      align: {
        end: 'items-end',
        start: 'items-start',
      },
    },
  },
);

export const cvaPaygSelectCardContentItemTitle = cva([
  'pricingCard-paygSelectCardContentItemTitle',
  'text-font_os_body_black_24 text-main_black',
]);

export const cvaPaygSelectCardContentItemDescription = cva([
  'pricingCard-paygSelectCardContentItemDescription',
  'text-font_os_body_caption_12 text-main_black',
]);

export const cvaAiTokensUpperSubtitle = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensUpperSubtitle',
  'font-normal text-[20px] leading-[24px] text-[#98D4F2] mb-2',
  'sm-max:text-[1rem]',
]);

export const cvaAiTokensSecondaryTitle = cva([
  'pricingCard-cvaAiTokensSecondaryTitle',
  'ff-raleway font-bold text-[32px] leading-[36px] text-[#FFFFFF] mb-4',
]);

export const cvaAiTokensSubtitle = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensSubtitle',
  'font-normal text-[20px] leading-[24px] text-[#FFFFFF] mb-4',
]);

export const cvaAiTokensDescription = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensDescription',
  'font-normal text-[16px] leading-[20px] text-[#98D4F2]',
]);

export const cvaAiTokensPriceBox = cva([
  'pricingCard-cvaAiTokensPriceBox',
  'border border-main_white rounded-[16px]',
  'flex items-center justify-between',
  'py-4 px-6',
  'mb-4',
  'w-full',
  'border border-1 border-solid border-main_white',
]);

export const cvaAiTokensPriceValue = cva([
  'pricingCard-cvaAiTokensPriceValue',
  'ff-os-hebrew font-bold text-[24px] leading-[28px] text-main_white',
]);

export const cvaAiTokensPriceDescription = cva([
  'pricingCard-cvaAiTokensPriceDescription',
  'ff-os-hebrew font-normal text-[12px] leading-[12px] text-main_white text-right align-middle opacity-70',
]);

export const cvaPaygDownloadsDescription = cva([
  'pricingCard-cvaPaygDownloadsDescription',
  'ff-os-hebrew font-normal text-[12px] leading-[12px] text-main_white text-left mt-1 opacity-70',
]);

export const cvaAiTokensTokensCount = cva([
  'pricingCard-cvaAiTokensTokensCount',
  'ff-os-hebrew font-bold text-[24px] leading-[28px] text-main_white',
]);

export const cvaAiTokensCommitment = cva([
  'pricingCard-cvaAiTokensCommitment',
  'ff-inter font-normal text-[16px] leading-[16px] text-[#98D4F2] text-center',
]);

export const cvaAllProPlansInclude = cva([
  'ff-inter',
  'pricingCard-cvaAllProPlansInclude',
  'font-bold text-[20px] leading-[24px] text-main_black mb-[10px]',
]);

export const cvaAiTokensTitle = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensTitle',
  'font-bold text-[20px] leading-[24px] text-main_black mb-[10px]',
]);

export const cvaAiTokensDescriptionText = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensDescriptionText',
  'font-normal text-[16px] leading-[20px] text-main_black mb-[10px]',
]);

export const cvaAiTokensFreeToUse = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensFreeToUse',
  'font-normal text-[16px] leading-[20px] text-main_black',
]);

export const cvaAiTokensList = cva([
  'pricingCard-cvaAiTokensList',
  'flex flex-col gap-[10px] sm-max:gap-[0.5rem] mb-[10px]',
]);

export const cvaAiTokensListItem = cva([
  'ff-inter',
  'pricingCard-cvaAiTokensListItem',
  'flex items-center gap-2 text-font_raleway_body_16 text-general_text_MII_secondary_i',
  'sm-max:text-[1rem] sm-max:items-start',
]);
